"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_components_tooltip_1 = require("@saatva-bits/pattern-library.components.tooltip");
const pattern_library_hooks_use_breakpoints_1 = require("@saatva-bits/pattern-library.hooks.use-breakpoints");
const PriceRange_1 = __importDefault(require("../PriceRange"));
const ProductSummary_module_scss_1 = __importDefault(require("./ProductSummary.module.scss"));
/**
 * Renders the most important info at a glance for a product
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.subtitle
 * @param {boolean} props.hideStrikethrough
 * @param {string} props.tooltip
 * @param {import('../../typedefs').Product} props.product
 * @param {string[]} props.selectedSizes
 * @param {{
 *  useGetDiscounts: import('../../typedefs').UseGetDiscounts,
 *  applyDiscounts: import('../../typedefs').ApplyDiscounts
 * }} props.promotionDeps - promotion context dependencies
 * @param {{
 *  useProductState: import('../../typedefs').UseProductState
 * }} props.selectionDeps - selection context dependencies
*/
const ProductSummary = ({ title, subtitle, tooltip, product, promotionDeps, selectionDeps, hideStrikethrough, selectedSizes = [] }) => {
    const { useGetDiscounts, applyDiscounts } = promotionDeps;
    const { useProductState } = selectionDeps;
    const { getDiscounts } = useGetDiscounts();
    const [tooltipOpen, setTooltipOpen] = (0, react_1.useState)(false);
    const { isMobile } = (0, pattern_library_hooks_use_breakpoints_1.useBreakpoints)('mobile');
    let lowestPrice = 0;
    let highestPrice = 0;
    let lowerPrice = 0;
    let upperPrice = 0;
    const hasSizeAttribute = product.configurableAttributes.includes('size');
    const { price, sku } = useProductState(product.productCode, ['price', 'sku']);
    if (hasSizeAttribute) {
        ({ lowestPrice, highestPrice, lowerPrice, upperPrice } = applyDiscounts([product], getDiscounts, selectedSizes)[0]); // eslint-disable-line
    }
    else {
        const { fullPrice, finalPrice } = getDiscounts([{
                sku,
                parentSku: product.productCode,
                quantity: 1,
                price
            }]);
        lowestPrice = fullPrice;
        highestPrice = fullPrice;
        lowerPrice = finalPrice;
        upperPrice = finalPrice;
    }
    // TODO: Update the logic and naming for lowestPrice/lowerPrice and highestPrice/upperPrice
    const priceRange = {
        lowestPrice,
        highestPrice,
        lowestPriceDiscount: hideStrikethrough ? lowestPrice : lowerPrice,
        highestPriceDiscount: hideStrikethrough ? highestPrice : upperPrice
    };
    return ((0, jsx_runtime_1.jsxs)("section", { className: ProductSummary_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsx)("h2", { className: `t-heading1 t-color ${ProductSummary_module_scss_1.default.title}`, children: title }), (0, jsx_runtime_1.jsxs)("div", { className: ProductSummary_module_scss_1.default.subtitle, children: [subtitle, ' ', tooltip && ((0, jsx_runtime_1.jsx)(pattern_library_components_tooltip_1.Tooltip, { bumperBottom: "0", bumperLeft: "10px", bumperRight: "0", bumperTop: "5px", dialogWidth: "250px", className: ProductSummary_module_scss_1.default.tooltip, dialogClassName: ProductSummary_module_scss_1.default.tooltipDialog, isToolTipActive: tooltipOpen, toggleToolTip: (_, activeState) => setTooltipOpen(activeState), toolTipTextBlocks: [tooltip], isMobile: isMobile }))] }), priceRange && (0, jsx_runtime_1.jsx)(PriceRange_1.default, { priceRange: priceRange, className: `${ProductSummary_module_scss_1.default.mainPriceRange} t-color`, discountClassName: ProductSummary_module_scss_1.default.strikeThrough })] }));
};
ProductSummary.propTypes = {
    title: prop_types_1.default.string.isRequired,
    subtitle: prop_types_1.default.string.isRequired,
    tooltip: prop_types_1.default.string,
    selectedSizes: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.string,
        value: prop_types_1.default.string
    })),
    /** Interface for promo context dependencies */
    promotionDeps: prop_types_1.default.shape({
        useGetDiscounts: prop_types_1.default.func,
        applyDiscounts: prop_types_1.default.func,
    }),
    /** Interface for selection context dependencies */
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func,
    }),
    product: prop_types_1.default.shape({
        productCode: prop_types_1.default.string,
        lowestPrice: prop_types_1.default.number,
        highestPrice: prop_types_1.default.number,
        configurableAttributes: prop_types_1.default.arrayOf(prop_types_1.default.string),
        variants: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            sku: prop_types_1.default.string,
            productCode: prop_types_1.default.string,
            category: prop_types_1.default.string,
            price: prop_types_1.default.number,
        }))
    }),
    hideStrikethrough: prop_types_1.default.bool
};
exports.default = ProductSummary;
//# sourceMappingURL=ProductSummary.js.map